import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ScrollView, View, Text } from 'react-native';
import { Background, Button, ConfirmationModal, useConfirmationModal } from 'LocalGluons';
import { t } from 'Locale';
import appManager from 'AppManager';
import styles from './ClearCache.jss';

const buttonStyle = {
    button: {
        ...styles.button,
        minWidth: 300,
        marginBottom: 15
    }
};
const ClearCache = (props) => {
    const { setModalContent } = useConfirmationModal();
    const [disabled, setDisabled] = useState(false);

    const closeDialog = async () => {
        setModalContent(null);
    };

    const clearCache = () => {
        appManager.wipeCache();
        setDisabled(true);
        setModalContent(
            <ConfirmationModal
                icon="success"
                message={t('COMMON.CLEAR_CACHE_CONFIRMATION')}
                confirmLabel={t('COMMON.OK')}
                onConfirm={() => {
                    closeDialog();
                }}
                onClose={closeDialog}
            />
        );
    };

    return (
        <Background>
            <ScrollView contentContainerStyle={styles.container}>
                <Text style={styles.whiteText}>{t('COMMON.CLEAR_CACHE_TITLE_TXT')}</Text>
                <View style={styles.buttonWidth}>
                    <Button
                        isDisabled={disabled}
                        style={buttonStyle}
                        title={t('COMMON.CLEAR_CACHE_BTN')}
                        onPress={clearCache}
                    />
                </View>
            </ScrollView>
        </Background>
    );
};

ClearCache.propTypes = {
    navigation: PropTypes.shape({}).isRequired
};

export default ClearCache;
